import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { History } from "history";
import { Provider as ReduxProvider } from "react-redux";
import { Route, Router } from "react-router-dom";
import { AnyAction, Store } from "redux";
import { ThemeProvider } from "theme-ui";
import { QueryParamProvider } from "use-query-params";
import LaunchDarklyProvider from "../../features/launchdarkly/LaunchDarklyProvider";
import { queryClient } from "../../http/query";
import { RootState } from "../../redux/root";
import theme from "../../styles/theme";
import { IS_DEVELOPMENT } from "@util/deployEnv.ts";
import { trpc, trpcClient } from "@util/trpc/trpcClient.ts";

interface ProvidersProps {
  store: Store<RootState, AnyAction>;
  history: History;
  children?: React.ReactNode;
}

const Providers = ({ store, history, children }: ProvidersProps) => {
  return (
    <ReduxProvider store={store}>
      <Router history={history}>
        <QueryParamProvider ReactRouterRoute={Route}>
          <ThemeProvider theme={theme}>
            <trpc.Provider client={trpcClient} queryClient={queryClient}>
              <QueryClientProvider client={queryClient}>
                <LaunchDarklyProvider>
                  {IS_DEVELOPMENT && <ReactQueryDevtools />}
                  {children}
                </LaunchDarklyProvider>
              </QueryClientProvider>
            </trpc.Provider>
          </ThemeProvider>
        </QueryParamProvider>
      </Router>
    </ReduxProvider>
  );
};

export default Providers;
